<div class="modal-header">
  <h4 *ngIf="!isDetailMode" class="modal-title pull-left">
    {{
    itemToSave?.id
    ? "Modification "+title
    : "Enregistrement "+title
    }}
  </h4>
  <!-- <h4 class="modal-title pull-left">
    Détails barème
  </h4> -->
  <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
  <ng-container>
    <mat-accordion class="bareme-accordion">

      <!-- ── 0 · DEFINITION ────────────────────────────────────────── -->
      <mat-expansion-panel [expanded]="indiceTab == 0" (opened)="indiceTab = 0; selectedChangeValue(0)">
        <mat-expansion-panel-header>
          <mat-panel-title>ENTETE BAREME</mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="indiceTab == 0" style="overflow-x: hidden">
          <div class="row" style="padding: 10px; min-height: 200px;">

            <div class="col-xl-3 col-lg-3 col-md-3 select-container col-sm-3 mb-1" style="position:relative">
              <label (click)="openDetailModal('garant')" [ngClass]="{'isSelectedItem':itemToSave.garant_id}"> Garant :
                <span class="required_champs">*</span>
              </label>
              <ng-select [disabled]="itemToSave.id || isDetailMode" (change)="getItemsProduitByGarant()"
                [(ngModel)]="itemToSave.garant_id" placeholder="Choisissez " name="garant_id" id="garant_id"
                [multiple]="false" [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsGarant" [value]="item.id">{{ item?.libelle }}</ng-option>
              </ng-select>
            </div>

            <div *ngIf="!itemToSave.id" class="col-xl-3 col-lg-3 col-md-3 select-container col-sm-3 mb-1"
              style="position: relative;">
              <label (click)="openDetailModal('produit')" [ngClass]="{'isSelectedItem':itemToSave.produit_id}">Produit :
                <span class="required_champs">*</span>
              </label>
              <ng-select [disabled]="isDetailMode" *ngIf="!itemToSave.id" [(ngModel)]="itemToSave.produit_id"
                (change)="onChangeProduit()" placeholder="Choisissez " name="produit_id" id="produit_id"
                [multiple]="false" [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsGarantProduit" [value]="item.id">{{ item?.libelle }}</ng-option>
              </ng-select>
              <input *ngIf="itemToSave.id" class="form-control" type="text" disabled [value]="product_libelle">
            </div>

            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
              <label>Libellé : <span class="required_champs">*</span></label>
              <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Libellé"
                autocomplete="off" [(ngModel)]="itemToSave.libelle" name="libelle" type="text" />
            </div>

            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
              <label>Description:</label>
              <textarea [disabled]="isDetailMode" class="form-control custom-input" [(ngModel)]="itemToSave.description"
                name="description" placeholder="Description" cols="30" rows="2"></textarea>
            </div>

            <div *ngIf="currentProduit && currentProduit.id" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1"
              style="padding-left: 5px; padding-right: 5px">
              <mat-tab-group mat-align-tabs="start" #tabGroup2 (selectedIndexChange)="selectedChangeValue2($event)"
                [(selectedIndex)]="indiceTab2">
                <mat-tab label="PRODUIT">
                  <app-bar-produit-bareme (onUpdateProduitBareme)="onUpdateProduitBareme($event)"
                    [currentProduit]="currentProduit" [currentBareme]="currentBareme"></app-bar-produit-bareme>
                </mat-tab>

                <mat-tab label="PRIME PAR STATUT" *ngIf="currentModeCalculPrime == 'STATUT'">
                  <div style="overflow-x: hidden">
                    <div class="container-fluid">
                      <app-bar-prime-statut [currentBareme]="currentBareme" [currentProduit]="currentProduit"
                        (onChangePrimeStatutForm)="onChangePrimeStatutForm($event)"
                        (onChangeModeTarification)="onChangeModeTarification($event)"></app-bar-prime-statut>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab *ngIf="currentModeCalculPrime == 'TRANCHE-AGE-STATUT'" label="PRIME PAR TRANCHE D'AGE STATUT">
                  <div style="overflow-x: hidden">
                    <div class="container-fluid">
                      <app-bar-prime-tranche-age-statut [currentBareme]="currentBareme"
                        [currentProduit]="currentProduit"
                        (onChangePrimeTrancheAgeStatutForm)="onChangePrimeTrancheAgeStatutForm($event)"></app-bar-prime-tranche-age-statut>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab *ngIf="currentModeCalculPrime == 'TRANCHE-AGE'" label="PRIME PAR TRANCHE D'AGE">
                  <div style="overflow-x: hidden">
                    <div class="container-fluid">
                      <app-bar-prime-tranche-age [currentBareme]="currentBareme" [currentProduit]="currentProduit"
                        (onChangePrimeTrancheAgeForm)="onChangePrimeTrancheAgeForm($event)"></app-bar-prime-tranche-age>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="PRIME PAR BUDGET" *ngIf="currentModeCalculPrime == 'BUDGET'">
                  <div style="overflow-x: hidden">
                    <div class="container-fluid">
                      <app-bar-prime-budget [currentBareme]="currentBareme" [currentProduit]="currentProduit"
                        (onChangePrimeStatutForm)="onChangePrimeBudgetForm($event)"></app-bar-prime-budget>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="GARANTIES">
                  <div style="overflow-x: hidden">
                    <app-bar-garantie [currentBareme]="currentBareme" [currentProduit]="currentProduit"
                      (onChangeGarantieForm)="onChangeGarantieForm($event)"></app-bar-garantie>
                  </div>
                </mat-tab>

                <mat-tab label="AFFECTIONS">
                  <div style="overflow-x: hidden">
                    <app-bar-affection-produit [currentBareme]="currentBareme" [currentProduit]="currentProduit"
                      (onChangeAffectionBaremeForm)="onChangeAffectionBaremeForm($event)"></app-bar-affection-produit>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>

          </div>
        </div>
      </mat-expansion-panel>
      <!-- CORPS DU BARME -->
      <!-- ── 1 · BAREME GARANTIES ─────────────────────────────────── -->
      <mat-expansion-panel [expanded]="indiceTab == 1" (opened)="indiceTab = 1; selectedChangeValue(1)"
        [disabled]="!currentBareme || !currentBareme.id">
        <mat-expansion-panel-header (click)="onDisabledPanelClick()">
          <mat-panel-title>BAREME GARANTIES</mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="indiceTab == 1" style="overflow-x: hidden">
          <app-new-garantie-bareme [isDetailMode]="isDetailMode" (onHideFormEvent)="onHideFormEvent($event)"
            [currentBareme]="currentBareme" [currentProduitBareme]="currentProduit"></app-new-garantie-bareme>
        </div>
      </mat-expansion-panel>

      <!-- ── 2 · BAREME GARANTIES STATUT ─────────────────────────── -->
      <mat-expansion-panel [expanded]="indiceTab == 2" (opened)="indiceTab = 2; selectedChangeValue(2)"
        [disabled]="!currentBareme || !currentBareme.id">
        <mat-expansion-panel-header (click)="onDisabledPanelClick()">
          <mat-panel-title>BAREME GARANTIES STATUT</mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="indiceTab == 2" style="overflow-x: hidden">
          <app-new-garantie-bareme-statut [isDetailMode]="isDetailMode" (onHideFormEvent)="onHideFormEvent($event)"
            [currentBareme]="currentBareme" [currentProduitBareme]="currentProduit"></app-new-garantie-bareme-statut>
        </div>
      </mat-expansion-panel>

      <!-- ── 3 · BAREME ACTES ─────────────────────────────────────── -->
      <mat-expansion-panel [expanded]="indiceTab == 3" (opened)="indiceTab = 3; selectedChangeValue(3)"
        [disabled]="!currentBareme || !currentBareme.id">
        <mat-expansion-panel-header (click)="onDisabledPanelClick()">
          <mat-panel-title>BAREME ACTES</mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="indiceTab == 3" style="overflow-x: hidden">
          <app-new-acte-bareme [isDetailMode]="isDetailMode" (onHideFormEvent)="onHideFormEvent($event)"
            (onHideForm)="onHideForm($event)" [currentBareme]="currentBareme"
            [currentProduitBareme]="currentProduit"></app-new-acte-bareme>
        </div>
      </mat-expansion-panel>

      <!-- ── 4 · BAREME ACTES STATUT ──────────────────────────────── -->
      <mat-expansion-panel [expanded]="indiceTab == 4" (opened)="indiceTab = 4; selectedChangeValue(4)"
        [disabled]="!currentBareme || !currentBareme.id">
        <mat-expansion-panel-header (click)="onDisabledPanelClick()">
          <mat-panel-title>BAREME ACTES STATUT</mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="indiceTab == 4" style="overflow-x: hidden">
          <app-new-acte-bareme-statut [isDetailMode]="isDetailMode" (onHideFormEvent)="onHideFormEvent($event)"
            (onHideForm)="onHideForm($event)" [currentBareme]="currentBareme"
            [currentProduitBareme]="currentProduit"></app-new-acte-bareme-statut>
        </div>
      </mat-expansion-panel>

    </mat-accordion>
  </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
    <button *ngIf="!isDetailMode" type="button" (click)="confirmSaveItem(itemToSave)"
      class="btn btn-md custom_btn_primary pull-right" [class.auth-spinner]="loading" [disabled]="loading">
      Sauvegarder
    </button>

    <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
      Annuler
    </button>
  </div>
</div>